// Imports
import "./SwipeableModals.scss";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  selectedNotification,
}) => {
  const renderNotificationView = () => {
    if (!selectedNotification) {
      return (
        <div className="user-modal">
          <p>لا توجد بيانات متاحة</p>
        </div>
      );
    }

    // Display notification details
    return (
      <div className="user-modal">
        <p className="user-modal-p">تفصيل الاشعار</p>
        {/* Use notification image if available, otherwise use default */}
        <img
          src={selectedNotification?.image}
          alt=""
          className="notification-img"
        />

        {/* Arabic content */}
        <span className="ar-name">
          {selectedNotification.title_ar || "عنوان الاشعار"}
        </span>
        <p className="ar-desc">
          {selectedNotification.body_ar || "لا يوجد وصف بالعربية"}
        </p>

        {/* English content */}
        <span className="en-name">
          {selectedNotification.title_en || "Notification Title"}
        </span>
        <p className="en-desc">
          {selectedNotification.body_en || "No English description available"}
        </p>

        {/* Additional notification details if available */}
        {selectedNotification.created_at && (
          <div className="notification-date">
            <span className="date-label">تاريخ الانشاء:</span>
            <span className="date-value">
              {new Date(selectedNotification.created_at).toLocaleDateString(
                "ar-EG"
              )}
            </span>
          </div>
        )}

        {selectedNotification.sent_to && (
          <div className="notification-recipients">
            <span className="recipients-label">تم الارسال الى:</span>
            <span className="recipients-value">
              {selectedNotification.sent_to}
            </span>
          </div>
        )}
      </div>
    );
  };

  const renderDefaultView = () => <div></div>;

  const views = {
    viewNotification: renderNotificationView,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
